import { useMaskito } from '@maskito/react';

import type { MaskitoOptions } from '@maskito/core';

export type MaskType = 'cardMask' | 'expirationMask' | 'cvvMask' | 'cbuMask' | 'none';

const createDigitMask = (length: number) => Array(length).fill(/\d/);

const maskOptions: Record<MaskType, MaskitoOptions> = {
  cardMask: {
    mask: [
      ...createDigitMask(4),
      ' ',
      ...createDigitMask(4),
      ' ',
      ...createDigitMask(4),
      ' ',
      ...createDigitMask(4),
    ],
  },
  expirationMask: {
    mask: [/\d/, /\d/, '/', /\d/, /\d/],
  },
  cvvMask: {
    mask: createDigitMask(3),
  },
  cbuMask: {
    mask: createDigitMask(22),
  },
  none: {
    mask: /.*/,
  },
};

const useMask = (maskType: MaskType = 'none') => {
  // ✅ useMaskito devuelve directamente el RefCallback
  const maskRef = useMaskito({ options: maskOptions[maskType] });
  return maskRef;
};

export default useMask;
